import { baseURL } from "../../configurations/environment";
import Axios from "axios";

const facebookRequestError = (error) => ({
  status: false,
  message: error.response?.data?.message,
  data: error.response?.data?.data,
  httpStatus: error.response?.status,
});

export const isInactiveSignalSubscription = (result) =>
  result?.httpStatus === 403 && result?.data?.has_active_subscription === false;

export const createBussinesApi = async (form) => {
  let requestURL = baseURL + `/api/facebook/onboard`;
  let responseResult = {
    status: "",
    message: "",
    data: "",
  };
  await Axios.post(requestURL, form)
    .then((response) => {
      responseResult = {
        status: true,
        message: response.data && response.data.message && response.data.message,
        data: response.data && response.data.data && response.data.data,
      };
    })
    .catch((error) => {
      responseResult = {
        status: false,
        message: error.response?.data?.message,
      };
    });
  return responseResult;
};

export const checkIfExistBusiness = async (token) => {
  let requestURL = baseURL + `/api/facebook/onboard/verify`;
  let responseResult = {
    status: "",
    message: "",
    data: "",
  };
  await Axios.post(requestURL, token)
    .then((response) => {
      responseResult = {
        status: true,
        message: response.data && response.data.message && response.data.message,
        data: response.data && response.data.data && response.data.data,
      };
    })
    .catch((error) => {
      responseResult = facebookRequestError(error);
    });
  return responseResult;
};

export const createTrackersApi = async (form) => {
  let requestURL = baseURL + `/api/facebook/tracker`;
  let responseResult = {
    status: "",
    message: "",
    data: "",
  };
  await Axios.post(requestURL, form)
    .then((response) => {
      responseResult = {
        status: true,
        message: response.data && response.data.message && response.data.message,
        data: response.data && response.data.data && response.data.data,
      };
    })
    .catch((error) => {
      responseResult = facebookRequestError(error);
    });
  return responseResult;
};
